<div
  class="auth-hero-carousel"
  role="region"
  [attr.aria-label]="i18nPrefix() + '.aria-region' | transloco"
  [attr.aria-roledescription]="i18nPrefix() + '.aria-roledescription' | transloco"
>
  <div class="viewport">
    @if (slideInView()) {
      <div
        class="slide"
        @heroSlide
        [@.disabled]="reduceMotion()"
        (@heroSlide.done)="onSlideAnimDone($event)"
      >
        <h2 class="carousel-line heading">
          {{ textKey(activeIndex(), 'title') | transloco }}
        </h2>
        <div class="slide-content">
          <p class="carousel-line lead">
            {{ textKey(activeIndex(), 'lead') | transloco }}
          </p>
          <p class="carousel-line detail">
            {{ textKey(activeIndex(), 'detail') | transloco }}
          </p>
        </div>
      </div>
    }
  </div>

  <div
    class="tabs"
    role="tablist"
    [attr.aria-label]="i18nPrefix() + '.aria-tabs' | transloco"
  >
    @for (i of slideIndices(); track i) {
      <button
        type="button"
        class="tab"
        role="tab"
        [attr.id]="'auth-hero-tab-' + i"
        [attr.aria-selected]="activeIndex() === i"
        [attr.tabindex]="activeIndex() === i ? 0 : -1"
        [attr.aria-label]="
          i18nPrefix() + '.aria-tab' | transloco: { current: i + 1, total: slideCount }
        "
        (click)="goTo(i)"
      >
        <span class="track" aria-hidden="true">
          <span
            class="fill"
            [style.transform]="'scaleX(' + fillScale(i) + ')'"
          ></span>
        </span>
      </button>
    }
  </div>
</div>
